export const Overlay: React.FC<{ hide: (e: any) => any; className?: string }> = ({ hide, className }) => (
    <span onClick={hide} className={`z-20 fixed top-0 left-0 w-full h-full bg-black bg-opacity-25 ${className}`} />
);
